import { useState } from 'react';

const ADMIN_EMAILS = ['marc@defineholy.com', 'angela@defineholy.com'];

function MemoryManager({ memory, userEmail, onClose }) {
  const [tab, setTab] = useState('core');
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState('');

  const isAdmin = ADMIN_EMAILS.includes(userEmail.toLowerCase());
  const items = tab === 'core' ? memory.coreMemories : memory.workingMemories;

  function startEdit(item) {
    setEditingId(item.id);
    setEditText(item.fact);
  }

  async function saveEdit(isCore) {
    if (!editText.trim()) return;
    await memory.updateMemory(editingId, isCore, editText.trim());
    setEditingId(null);
    setEditText('');
  }

  async function handleDelete(item, isCore) {
    if (!window.confirm('Delete this memory?')) return;
    await memory.deleteMemory(item.id, isCore);
  }

  async function handlePromote(item) {
    if (!window.confirm(`Move "${item.fact.substring(0, 50)}..." to Core Memory? It will be visible to all family members.`)) return;
    await memory.promoteToCore(item.id);
  }

  async function handleClearAll() {
    if (!window.confirm('Are you sure? This removes all your auto-saved working memories.')) return;
    await memory.clearAllWorking();
  }

  async function handleUnflagReview(item) {
    await memory.updateMemory(item.id, true, item.fact); // triggers refetch; unflag happens via markUsed
    await memory.markUsed([item.id]);
  }

  function formatDate(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  return (
    <div className="MemMgr-overlay" onClick={onClose}>
      <div className="MemMgr" onClick={e => e.stopPropagation()}>
        <div className="MemMgr-header">
          <h3>Memory Bank</h3>
          <button className="RoleManager-close" onClick={onClose}>&times;</button>
        </div>

        <div className="MemMgr-tabs">
          <button
            className={`MemMgr-tab${tab === 'core' ? ' MemMgr-tab--active' : ''}`}
            onClick={() => setTab('core')}
          >Core ({memory.coreMemories.length})</button>
          <button
            className={`MemMgr-tab${tab === 'working' ? ' MemMgr-tab--active' : ''}`}
            onClick={() => setTab('working')}
          >Working ({memory.workingMemories.length})</button>
        </div>

        {tab === 'working' && memory.workingMemories.length > 0 && (
          <button className="MemMgr-clear-btn" onClick={handleClearAll}>Clear All Working Memory</button>
        )}

        <div className="MemMgr-list">
          {items.length === 0 && (
            <p className="Centcom-events-empty">
              {tab === 'core' ? 'No core memories yet.' : 'No working memories yet.'}
            </p>
          )}
          {items.map(item => (
            <div key={item.id} className={`MemMgr-item${item.flaggedForReview ? ' MemMgr-item--flagged' : ''}`}>
              {editingId === item.id ? (
                <div className="MemMgr-edit">
                  <textarea
                    className="MemMgr-edit-input"
                    value={editText}
                    onChange={e => setEditText(e.target.value)}
                    rows={2}
                  />
                  <div className="MemMgr-edit-actions">
                    <button className="Fitness-btn Fitness-btn--small" onClick={() => saveEdit(tab === 'core')}>Save</button>
                    <button className="Fitness-btn Fitness-btn--small Fitness-btn--secondary" onClick={() => setEditingId(null)}>Cancel</button>
                  </div>
                </div>
              ) : (
                <>
                  <p className="MemMgr-fact">{item.fact}</p>
                  <div className="MemMgr-meta">
                    <span>Created {formatDate(item.createdDate)}</span>
                    <span>Used {item.timesUsed}x</span>
                    {item.lastUsed && <span>Last {formatDate(item.lastUsed)}</span>}
                    {tab === 'working' && <span className="MemMgr-score">Score: {item.relevanceScore}</span>}
                    {item.flaggedForReview && <span className="MemMgr-flag">Needs review</span>}
                    {item.expirationDate && <span>Expires {formatDate(item.expirationDate)}</span>}
                  </div>
                  <div className="MemMgr-actions">
                    {/* Core: only admins can edit/delete */}
                    {tab === 'core' && isAdmin && (
                      <>
                        <button className="Fitness-btn-icon" onClick={() => startEdit(item)} title="Edit">&#9998;</button>
                        <button className="Fitness-btn-icon Fitness-btn-icon--delete" onClick={() => handleDelete(item, true)} title="Delete">&times;</button>
                        {item.flaggedForReview && (
                          <button className="Fitness-btn Fitness-btn--small Fitness-btn--secondary" onClick={() => handleUnflagReview(item)}>Unflag</button>
                        )}
                      </>
                    )}
                    {/* Working: owner can edit/delete/promote */}
                    {tab === 'working' && (
                      <>
                        <button className="Fitness-btn-icon" onClick={() => startEdit(item)} title="Edit">&#9998;</button>
                        <button className="Fitness-btn-icon Fitness-btn-icon--delete" onClick={() => handleDelete(item, false)} title="Delete">&times;</button>
                        <button className="Fitness-btn Fitness-btn--small Fitness-btn--secondary" onClick={() => handlePromote(item)}>Move to Core</button>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MemoryManager;
